<template>
  <div class="contact-wrap">
    <div v-if="!showContact">
        <div class="contact-icon" @click="(e)=>handleShow(e,true)">
          <div class="contact-icon-wrap">
            <img src="../assets/img/icon-contact2.png" alt="logo"/>
          </div>
          <template v-if="recharged===1">
            <div class="contact-icon-left">{{tip}}</div>
          </template>
        </div>
    </div>

    <div class="contact-box" v-else>
      <div class="contact-item">
          <p v-if="hoverIndex===2">{{contactTips[1]}}</p>
          <div class="blue" @mouseenter="(e)=>handleIndex(e,2)" @mouseleave="handleHide">
            <a rel="nofollow" href="https://teams.live.com/l/invite/FEAOtIKX0rDmnGUuwE" target="_blank" class="item">
              <img class="contact-skyle" src="../assets/img/icon-teams2.png" alt="logo"/>
            </a>
          </div>
      </div>
      <div class="contact-item">
        <p v-if="langChange">{{$t('messages.gLogin.contactTip2')}}</p>
        <p v-else>Recommend to contact us on WhatsApp!</p>
        <div class="lv">
          <a rel="nofollow" href="https://wa.me/8618028539642" target="_blank" class="item">
            <img class="contact-app" src="../assets/img/icon-call.png" alt="logo"/>
          </a>
        </div>
      </div>
      <div class="contact-item">
        <div class="hui" @click="(e)=>handleShow(e,false)">
          <img class="contact-close" src="../assets/img/icon-cha.png" alt="logo"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    recharged: {
      type: Number,
      default: 0,// 1代表是首次充值，0代表不是
    },
    callback: {
      type: Function,
    },
    langChange:{
      type: Boolean,
      default: true,// 1代表是首次充值，0代表不是
    },
  },
  data() {
      return {
        showContact:false,
        contactTips:['Telegram online','Teams online'],// WhatsApp online
        hoverIndex:null,
        tip:'Contact us to get free trial!',
        showNum:true,
      }
  },
  created(){
    this.$EventBus.$on('showContact', () => {// 监听事件
      this.showContact = true
    })
  },
  beforeDestroy() {
    this.$EventBus.$off('showContact');
  },
  methods: {
    handleIndex(e,type){
      this.hoverIndex = type
    },
    handleHide(){
      this.hoverIndex = null
    },
    handleShow(e,status){
      this.showNum=false
      this.showContact = status
      this.$emit('callback',status)
      if(status&&process.env.NODE_ENV === 'production' && window.gtag){
        window.gtag('event', 'click-contact', { event_category: 'btnClick' })
      }
    },
  },
}

</script>

<style lang="scss">
.contact-wrap{
    position: fixed;
    bottom: 76px;
    right: 35px;
    z-index: 1000;
    .contact-icon{
      width: 60px;
      height: 60px;
      // background: rgba(67, 69, 75, 0.12);
      background: rgba(24,97,242,0.08);
      opacity: 1;
      border-radius: 50%;
      position: relative;
      cursor: pointer;
      .contact-icon-wrap{
        width: 48px;
        height: 48px;
        // background: #1861F2;
        background: linear-gradient(45deg, #7F17FF 0%, #1861F2 52%, #12BCFF 100%);
        opacity: 1;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -24px;
        margin-left: -24px;
        >img{
          // width: 24px;
          // height: 24px;
          width: 29px;
          height: 31px;
        }
      }
      .contact-icon-p{
        width: 18px;
        height: 18px;
        background: #F65D5D;
        font-size: 12px;
        color: #fff;
        border-radius: 50%;
        font-weight: 400;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 6px;
      }
      .contact-icon-left{
        cursor: default;
        width: 248px;
        height: 32px;
        border-radius: 4px;
        background: linear-gradient(45deg, #7F17FF 0%, #1861F2 52%, #12BCFF 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #fff;
        position: absolute;
        right: 75px;
        top: 14px;
      }
      .contact-icon-left::after{
        content:'';// 一定要有它，否则效果出不来
        position:absolute;// 给高亮元素定位，在这之前要给statusItem元素设置position:relative定位
        top:50%;
        transform: translate(0,-50%);// 居中显示
        border:6px solid transparent;// 小三角的大小
        // border-top-color:#428FFC;// 小三角朝下
        // border-bottom-color:#428FFC;// 小三角朝上
        border-left-color: rgba(18, 188, 255, 1);// 小三角朝右
        // border-right-color:#428FFC;// 小三角朝左
        right: -12px;
      }
    }
    .contact-box{
      display: flex;
      flex-direction: column;
      .contact-item{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 12px;
        min-width: 58px;
        padding-right: 7px;
        >p{
          background: #555555;
          border-radius: 4px;
          opacity: 1;
          font-weight: 400;
          color: #FFF;
          padding: 5px 12px;
          text-align: center;
          font-size: 14px;
        }
        >div{
          width: 46px;
          height: 46px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 8px;
        }
        .pink{
          background: #E30077;
        }
        .blue{
          background: #4b53bc;
        }
        .lv{
          background: #00CD4C;
        }
        .blue2{
          background: #38B0E3;
        }
        .hui{
          background: #D0D3D9;
        }
        img{
          width: 24px;
          height: 24px;
        }
        .item{
          padding: 0;
          margin: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &:nth-child(2){
          >p{
            height: 32px;
            padding: 0 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #00cd4c;
            position: relative;
            margin-right: 6px;
          }
          >p::after{
            content:'';// 一定要有它，否则效果出不来
            position:absolute;// 给高亮元素定位，在这之前要给statusItem元素设置position:relative定位
            top:50%;
            transform: translate(0,-50%);// 居中显示
            border:6px solid transparent;// 小三角的大小
            border-left-color: #00cd4c;// 小三角朝右
            right: -12px;
          }
        }
      }
      .contact-item:last-child{
        margin-bottom: 0;
      }
      .contact-close{
        cursor: pointer;
      }
    }
}
@media screen and (max-width: 768px){
  .contact-wrap{
    right: 8px;
  }
}
</style>